import React,{useContext,useEffect, useState, useRef} from 'react';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest } from '../../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon, PrintIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon} from "../../svg/svgIcons";
import { Dialog } from 'primereact/dialog';
import { InfinitySpin } from  'react-loader-spinner';
import AuthContext from '../../../components/AuthContext';
import UtilContext from "../../../components/UtilContext";
import { LocaleContext } from '../../../components/LocaleContext';
import { createArrayNavigateHandlers } from '../../../utils/arrayNavigate';
import { MultiSelect } from 'primereact/multiselect';
import { Chips } from 'primereact/chips';

export default function PaintingEmployeeConditionAdd({painting_employee_condition, type}) {

    const [state,dispatch] = useContext(DatabaseContext);
    const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView} = useContext(UtilContext);
  const { t } = useContext(LocaleContext);
    const {user} = useContext(AuthContext);

    const [closeTab,setCloseTab] = useState(false);
    const submitRef = useRef(null);

    const [formEmployeeCondition,setFormTimeCondition] = useState(painting_employee_condition);
    const [formType, setFormType] = useState(type);

    //TODO dorobit contractor id
    const [insertCopyIcon,setInsertCopyIcon] = useState((user.permissions?.includes("add painting-setup"))?false:true);
    const [scrollIcons,setScrollIcons] = useState((user.permissions?.includes("edit painting-setup"))?false:true);
    const [visibleLoading,setVisibleLoading] = useState(false);

    function addNewPaintingCondition(){
        dispatch({type:'create_new_tab',name: t('PaintingTimeCondition.Tab.Add'), translationKey: 'PaintingTimeCondition.Tab.Add', legacyLabel: t('PaintingTimeCondition.Tab.Add'),page:'PaintingTimeConditionAdd',props:{painting_employee_condition: null,type:'add'},mask:'pain007'})
    }

    function copyPaintingCondition(){
        dispatch({type:'create_new_tab',name: t('PaintingTimeCondition.Tab.Add'), translationKey: 'PaintingTimeCondition.Tab.Add', legacyLabel: t('PaintingTimeCondition.Tab.Add'),page:'PaintingTimeConditionAdd',props:{painting_employee_condition: formik.values,type:'copy'},mask:'pain007'})
    }

    const validate = values => {
        const errors = {};
        if(values.name.length<5)errors.name = t('Common.NameTooShort');

        return errors;
    };

    const formik = useFormik({
        initialValues: formEmployeeCondition==null?{
            name: '',time_conditions:[],email_time:'',users:[],other_emails:''
        }:{
            id:formEmployeeCondition.id,name: formEmployeeCondition.name,
            time_conditions:formEmployeeCondition.time_conditions.map((employee) => ({id:employee.id,name:employee.name,from:employee.from,to:employee.to})),
            email_time:formEmployeeCondition.email_time,
            users:formEmployeeCondition.employees.map((employee) => ({name:employee.name,id:employee.id})),other_emails:formEmployeeCondition.other_emails ? formEmployeeCondition.other_emails.split(',') : []
        },
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            let formData = new FormData();
            for (let value in values) {
                if(value=="time_conditions"){
                    formData.append("time_conditions", values.time_conditions.map(condition => condition.id));
                }
                else if(value=="users"){
                    formData.append("employees", values.users.map(employee => employee.id));
                }
                else formData.append(value, values[value]);
            }
            if(formType=="add"){
                postRequest('/api/painting_employee_conditions', formData,true)
                .then((response) => {
                    console.log(response);
                    getRequest("/api/painting_employee_conditions").then((response) => {
                        dispatch({type:'load_painting_employee_conditions',newPaintingEmployeeConditions:response.data});
                        if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                        if(response.data.length-1>=0)formik.setFieldValue("id",response.data[response.data.length-1].id);
                        setFormType("edit");
                        toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                    });
                }).catch((reason) => {
                    if(!navigator.online){
                        alert(t('ServiceTask.OfflineQueuedAlert'));
                    }
                    else{
                        alert(t('Common.Toast.ActionFailedDetail'));
                    }
                })
            }
            else{
                postRequest(`/api/painting_employee_conditions/update/${formik.values.id}`, formData,true)
                .then((response) => {
                    getRequest("/api/painting_employee_conditions").then((response) => {
                        dispatch({type:'load_painting_employee_conditions',newPaintingEmployeeConditions:response.data});
                        if(closeTab)dispatch({type:'close_tab',id:state.selectedTab});
                        formik.setValues(values);
                        toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordUpdatedDetail') });
                    });
                }).catch((reason) => {
                    if(!navigator.online){
                        alert(t('ServiceTask.OfflineQueuedAlert'));
                    }
                    else{
                        alert(t('Common.Toast.ActionFailedDetail'));
                    }
                })
            }
        },
    });


    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = createArrayNavigateHandlers(state.painting_employee_conditions, formik.values.id, setFormTimeCondition);

    return (

        <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {setCloseTab(true);submitRef.current.click();}}><SaveAndCloseIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => {submitRef.current.click();}}><SaveIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewPaintingCondition()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => copyPaintingCondition()}><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
        </div>
        <form onSubmit={formik.handleSubmit}>
        <div className="relative flex flex-col justify-top overflow-x min-h-[calc(100vh-177px)] bg-gray-100">
          <div className='xl:grid grid-cols-2 gap-1 mb-2 '>
            <div className="w-auto p-6 m-4 bg-white rounded-md shadow-lg">
                <h1 className="text-2xl font-semibold text-left text-zinc-900">{t('Ui.R67.PODMIENKY_PRE_POUZIVATELOV')}</h1>
                {formType=="edit" && <label className="block text-md font-semibold text-gray-800">Por.č.: {formik.values.id}</label>}
                      <div>
                        <label
                            for="name"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.NAZOV_PODMIENKY')}</label>
                        <input
                            name='name'
                            type="text"
                            required
                            onChange={formik.handleChange} value={formik.values.name}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        {formik.errors.name ? <div style={{color:'red'}}>{formik.errors.name}</div> : null}
                        </div>
                        <div>
                        <label
                            for="from"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.NESPLNENE_PODMIENKY')}</label>
                        <MultiSelect value={formik.values.time_conditions} onChange={(e) => formik.setFieldValue("time_conditions",e.value)} options={state.painting_time_conditions} optionLabel="name"
                            filter placeholder={t('PaintingEmployeeConditionAdd.Placeholder.Conditions')} className="w-full px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                        </div>
                    
                      <div>
                        <label
                            for="email_time"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Otk.EmailSendTimeUpper')}</label>
                        <input
                            name='email_time'
                            type="time"
                            min="05:00" max="22:00"
                            required
                            onChange={formik.handleChange} value={formik.values.email_time}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            for="users"
                            className="block text-md font-semibold text-gray-800"
                        >
                            ZAMESTNANCI
                        </label>
                        <MultiSelect value={formik.values.users} onChange={(e) => formik.setFieldValue("users",e.value)} 
                        options={(state.employees || []).filter((employee) => employee.email != null && employee.email != "").map((employee) => 
                            ({name:employee.name,id:employee.id})
                        )} 
                        optionLabel="name" 
                        filter placeholder={t('PaintingEmployeeConditionAdd.Placeholder.Users')} className="w-full px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                        </div>
                        <div>
                        <label
                            for="other_emails"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Otk.OtherEmailsUpper')}</label>
                        <Chips value={formik.values.other_emails} onChange={(e) => formik.setFieldValue("other_emails",e.value)} separator="," className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                        </div>
                </div>              
            </div>
            </div>
            <button type="submit" ref={submitRef} className='hidden'></button>
            </form>
            </div>
            );
} 
